import React from "react";
import { facebookBtnImage } from "../../../assets";
import FacebookLogin from "react-facebook-login";
import { facebookAuthAppID, invokeApi } from "../../../bl_libs/invokeApi";
import { withRouter } from "react-router-dom";
import { useSockets } from "../../../Context/Context-Sockets/ContextSockets";
function FacebookAuth(props) {
  const { socketON } = useSockets();
  const {
    setOpenPhoneNumberScreen,
    setIsLoading,
    setAuth,
    handleReqPostData,
    reqPostData,
  } = props;

  const responseFacebook = (response) => {
    console.log(response);
    // EmailVarification(response);
    UserSignupWithFacebook(response.accessToken);
  };

  const failedInResponse = () => {};
  const EmailVarification = (response) => {
    let requestObj = {
      path: "/app_api/validate_Email",
      method: "POST",
      headers: {},
    };
    let postData = {
      email: response.email,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        if (res.status === 1) {
          UserSignupWithFacebook(response.accessToken);
        } else {
          setOpenPhoneNumberScreen(true);
          setAuth({
            email: response.email,
            accessToken: response.accessToken,
            authType: "facebook",
          });

          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    });
  };

  const UserSignupWithFacebook = (accessToken) => {
    let requestObj = {
      path: "/api/customer/login_by_facebook",
      method: "POST",
      headers: {},
    };
    let postData = {
      access_token: `${accessToken}`,
      phone_number: ``,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        let storage_obj = {
          ...res.data,
          ...res.data.user,
        };

        if (reqPostData) {
          handleReqPostData(res.data.auth_token, storage_obj);
          return;
        }

        localStorage.setItem("token", res.data.auth_token);
        localStorage.setItem("user", JSON.stringify(storage_obj));
        props.history.push("/dashboard");
        socketON();
      } else {
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <FacebookLogin
        appId={facebookAuthAppID}
        autoLoad={false}
        fields="name,email,picture"
        callback={responseFacebook}
        onFailure={failedInResponse}
        cssClass="facebook-btn-style"
        textButton=""
        icon={<img src={facebookBtnImage} />}
      />
    </>
  );
}

export default withRouter(FacebookAuth);
